import React from "react";

import logo from "../../../../assets/images/enageed_logo.png";

import styles from "./LogoutHeader.module.scss";

export const LogoutHeader = (props: {}) => (
  <nav className={styles.navHeader}>
    <img src={logo} alt="logo" />
  </nav>
);

export default LogoutHeader;
